export const ActivateIcon = ({
  width = 40,
  height = 40,
  title = "Activate your system",
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...props}>
    <title>{title}</title>
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M41.599 65.833V57.47c0-3.08-1.23-6.034-3.419-8.21l-8.191-8.148a2.732 2.732 0 0 0-3.851 0 2.696 2.696 0 0 0 0 3.83l8.144 8.1"
    />
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M25.844 41.402v-11.24a2.577 2.577 0 0 0-2.584-2.57 2.577 2.577 0 0 0-2.584 2.57v18.984c0 1.495.598 2.926 1.658 3.984l7.243 7.203a4.844 4.844 0 0 1 1.428 3.434v2.062h10.59v-8.362c0-3.08 1.23-6.033 3.419-8.21l8.191-8.147a2.732 2.732 0 0 1 3.85 0 2.696 2.696 0 0 1 0 3.83l-8.143 8.1"
    />
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M57.35 41.402v-11.24a2.577 2.577 0 0 1 2.585-2.57 2.577 2.577 0 0 1 2.584 2.57v18.984a5.628 5.628 0 0 1-1.659 3.984l-7.242 7.203a4.843 4.843 0 0 0-1.429 3.434v2.062H41.6M41.6 29.016v3.497"
    />
    <path
      fill="#00226A"
      d="M41.598 30.504a1.33 1.33 0 0 0 1.334-1.327 1.33 1.33 0 0 0-1.334-1.327 1.33 1.33 0 0 0-1.334 1.327 1.33 1.33 0 0 0 1.334 1.327Z"
    />
    <path
      stroke="#5DCDFF"
      strokeMiterlimit={10}
      d="M45.493 21.151h-7.792l-5.51 5.48v7.75l5.51 5.476h7.792l5.51-5.476v-7.75l-5.51-5.48Z"
    />
    <path
      stroke="#5DCDFF"
      strokeMiterlimit={10}
      d="M37.527 21.151v-4.697c0-1.35 1.18-2.449 2.632-2.449h2.878c1.452 0 2.631 1.096 2.631 2.45v4.696"
    />
  </svg>
);
